export default "__VITE_ASSET__3e511f66__"